import tw, { styled } from 'twin.macro';
import { variants } from '@/components/Link/Link.styles';

export const StyledMobileLabel = styled.div`
  ${tw`md:hidden`};
  ${tw`mb-[12px]`};
  ${tw`font-inter font-semi-bold`};
  ${tw`text-tag-s text-neutrals-n6`};
`;

export const StyledTabTitle = styled.span`
  ${variants['primary_small']}
  ${tw`bg-ui-colours-ui3`}
  ${tw`text-secondary-s1`}
  ${tw`border-ui-colours-ui3`}

  &:hover {
    ${tw`bg-ui-colours-ui3`}
    ${tw`text-ui-colours-ui2`}
    ${tw`border-ui-colours-ui2`}
  }
`;

export const StyledPreviousArrow = styled.button<{
  disabled: boolean;
}>`
  ${tw`flex md:hidden`}
  ${tw`absolute`}
  ${tw`left-0 top-[13px]`}
  ${tw`h-[40px] w-[40px]`}
  ${({ disabled }) => disabled && tw`hidden`}

  .icon {
    ${tw`w-[24px]`}
    ${tw`text-primary-p1`}
  }

  span {
    ${tw`sr-only`};
  }
`;

export const StyledNextArrow = styled(StyledPreviousArrow)`
  ${tw`left-auto right-0`}
  ${tw`justify-end`}

  .icon {
    ${tw`rotate-180`}
  }
`;

export const StyledTabs = styled.div`
  ${tw`relative`};

  .tabbed-block-tab-list {
    ${tw`flex flex-wrap justify-center gap-2`};
    ${tw`overflow-x-auto`};
    ${tw`-mx-2 lg:mx-0`};
    ${tw`pb-2 lg:pb-3`};
  }

  .tabbed-block-tab-list__item {
    ${tw`hidden w-auto`}
    ${tw`text-center`}
    ${tw`outline-none`}
    ${tw`md:inline-block`}
    ${tw`hover:cursor-pointer`}
    ${tw`rounded-[50px]`}

    &.react-tabs__tab--selected {
      ${tw`inline-block`}
      ${StyledTabTitle} {
        ${tw`bg-secondary-s1`}
        ${tw`text-neutrals-n1`}
        ${tw`border-secondary-s1`}

        &:hover {
          ${tw`bg-ui-colours-ui2`}
          ${tw`text-neutrals-n1`}
          ${tw`border-ui-colours-ui2`}
        }

        &:before,
        &:after {
          ${tw`content-none`}
        }
      }
    }
  }
`;

export const StyledContent = styled.div<{ isActive: boolean }>`
  ${tw`-mx-2 lg:mx-0`};
  ${({ isActive }) => !isActive && tw`hidden`}
`;
